import { useAccess } from './use-access';
import { canEdit } from '@/lib/sharing/utils/permissions';

/**
 * Returns true if the current user has edit permission on the given resource.
 *
 * Uses useAccess internally to support both docs and collections.
 * Accepts null/undefined — returns false immediately.
 * Returns false when the resource doesn't exist in the store.
 */
export function useCanEdit(id: string | null | undefined): boolean {
  const access = useAccess(id);
  return access ? canEdit(access) : false;
}
